




































import { Component, Prop, Vue } from 'vue-property-decorator';
import CollectionDescription, { CollectionObject as CollectionDescriptionItem } from './CollectionDescription.vue';

export interface CollectionObject {
  label?: string;
  img: string;
}

@Component({
  components: {
    CollectionDescription,
  },
})
export default class Collection extends Vue {
  @Prop({
    type: Array,
    required: true,
  })
  private items!: CollectionObject[];

  @Prop({
    type: Array,
    required: true,
  })
  private straws!: CollectionObject[];

  @Prop({
    type: Array,
    required: true,
  })
  private descriptions!: CollectionDescriptionItem[];
}
